var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-full" }, [
    _c("video", {
      key: this.options.sources[0].src,
      ref: "videoPlayer",
      staticClass: "video-js vjs-theme-forest vjs-16-9",
      attrs: { controls: "", preload: "auto" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "h-full", attrs: { id: "video-player-test" } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }